<!--
 * @Description:
 * @Date: 2019-09-19 10:19:57
 -->
<template>
  <div class="tag">
    <h2>学术拜访</h2>
    <span class="note-s1" v-if="!isChild">{{ content }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '学术拜访'
    },
    isChild: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    enableDt: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {
    content() {
      return this.isEdit && this.enableDt
        ? '注：风控条目选中后，ASP用户将可在SaaS前端进行对应项目风控调整'
        : `风控生效时间：${this.enableDt}`;
    }
  },
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
// 标签
.tag {
  font-weight: 500;
  font-size: 20px;
  position: relative;
  padding-left: 16px;
  display: flex;
  align-items: center;
  &::before {
    content: '';
    width: 8px;
    height: 24px;
    border-radius: 8px;
    background: #1989fa;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
